module.exports = __webpack_public_path__ + "img/smx.717e7f61.png";